import React from "react";
import { Button } from "./ui/button";

const AboutBook = () => {
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            O livro "A Vida de Jesus" é para você que deseja…
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div className="flex items-start space-x-4">
            <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
              <div className="w-6 h-6 bg-white rounded-full"></div>
            </div>
            <p className="text-lg text-gray-700">
              Caminhar ao lado de Jesus como se fosse um de Seus discípulos, testemunhando cada milagre e ensinamento.
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
              <div className="w-6 h-6 bg-white rounded-full"></div>
            </div>
            <p className="text-lg text-gray-700">
              Compreender a verdadeira prosperidade eterna que vai além do material e transforma o coração.
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
              <div className="w-6 h-6 bg-white rounded-full"></div>
            </div>
            <p className="text-lg text-gray-700">
              Aplicar os princípios do Reino de Deus em sua vida diária através de tarefas práticas e reflexivas.
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
              <div className="w-6 h-6 bg-white rounded-full"></div>
            </div>
            <p className="text-lg text-gray-700">
              Vivenciar uma narrativa harmoniosa dos quatro evangelhos em uma jornada contínua e transformadora.
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
              <div className="w-6 h-6 bg-white rounded-full"></div>
            </div>
            <p className="text-lg text-gray-700">
              Descobrir como viver as "obras maiores" prometidas por Jesus através do poder do Espírito Santo.
            </p>
          </div>

          <div className="flex items-start space-x-4">
            <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
              <div className="w-6 h-6 bg-white rounded-full"></div>
            </div>
            <p className="text-lg text-gray-700">
              Experimentar transformação espiritual profunda e encontrar propósito de vida através do Evangelho.
            </p>
          </div>
        </div>

        <div className="text-center mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">E muito, muito mais!</h3>
          <p className="text-lg text-gray-600 mb-8">
            Parece bom demais para ser verdade, né? Eu sei…
          </p>
        </div>

        <div className="bg-gray-50 rounded-xl p-8 text-center">
          <h3 className="text-3xl font-bold text-gray-900 mb-6">
            Este é o melhor caminho para uma transformação espiritual profunda!
          </h3>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed">
            Você terá acesso a uma narrativa única que harmoniza os quatro evangelhos, onde <strong>você</strong> se encontrará caminhando ao lado de Jesus. Mesmo que você tenha pouco tempo para leitura ou esteja buscando uma conexão mais profunda com a fé…
          </p>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed">
            Mesmo assim, você conquistará a tão sonhada <strong>paz interior e propósito de vida</strong> através desta jornada espiritual. Hoje, você viverá uma experiência transformadora <strong>— sem superficialidade, com profundidade real e aplicação prática que impacta sua vida diariamente.</strong>
          </p>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed">
            Este livro provou que seguindo os ensinamentos de Jesus e aplicando os princípios do Reino de Deus, <strong>é possível viver uma vida de propósito e prosperidade eterna, mesmo começando do absoluto zero espiritual.</strong>
          </p>

          <Button 
            onClick={scrollToPurchase}
            className="bg-red-600 hover:bg-red-700 text-white text-xl py-6 px-12 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300"
          >
            Quero ler A Vida de Jesus
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AboutBook;